import React from 'react';
import config from '../config';
import '../styles/Final.css';

function Final() {
  return (
    <section className="final" id="finalSec">
      <h2 className="reveal">
        把你的工作方法，<em>变成人人可得的 APP。</em>
      </h2>
      <p className="final-copy reveal">
        去应用市场发现并运行应用；需要继续修改时，再按页面标注获取 ZIP 完整工程。
      </p>
      <a 
        className="pill pill-dark pill-lg reveal" 
        href={config.market.home}
        target="_blank" 
        rel="noopener noreferrer"
      >
        进入应用市场 <span aria-hidden="true">↗</span>
      </a>
    </section>
  );
}

export default Final;
